import React from "react";
import { IoMdClose } from "react-icons/io";
import { Box, Flex } from "rebass";
import { getLocalizedString } from "../utils";
import OrderStatusGreen from "../icons/OrderStatusGreen";
import OrderStatusYellow from "../icons/OrderStatusYellow";
import OrderStatusRed from "../icons/OrderStatusRed";

const StatusViewMobile = ({ onClose }) => {
  return (
    <Flex
      width="100vw"
      height="calc(100dvh - 50px)"
      bg="#909090"
      flexDirection="column"
      style={{ position: "fixed", left: 0, top: "50px", zIndex: 5 }}
      p="10px"
    >
      <Flex width={1} justifyContent="end" onClick={onClose} mb="65px">
        <IoMdClose color="white" size="30px" />
      </Flex>

      <Box mx="30px" mb="20px">
        <span style={{ color: "white", fontSize: "16px", fontWeight: "bold" }}>
          {getLocalizedString("TABMENU_ORDER_DESCRIPTION")}
        </span>
      </Box>

      <Flex flexDirection="column" style={{ gap: "10px" }} mx="30px" mb="80px">
        <Flex alignItems="center">
          <OrderStatusGreen style={{ width: 20, marginRight: 5 }} />
          <span style={{ color: "white", fontSize: "16px" }}>
            {getLocalizedString("TABMENU_ORDER_OK")}
          </span>
        </Flex>
        <Flex alignItems="center">
          <OrderStatusYellow style={{ width: 20, marginRight: 5 }} />
          <span style={{ color: "white", fontSize: "16px" }}>
            {getLocalizedString("TABMENU_ORDER_WARN")}
          </span>
        </Flex>
        <Flex alignItems="center">
          <OrderStatusRed style={{ width: 20, marginRight: 5 }} />
          <span style={{ color: "white", fontSize: "16px" }}>
            {getLocalizedString("TABMENU_ORDER_ERROR")}
          </span>
        </Flex>
      </Flex>

      <Flex width={1} justifyContent="center">
        <button
          style={{
            border: "1px solid white",
            color: "white",
            borderRadius: "5px",
            width: "160px",
            height: "38px",
          }}
          onClick={onClose}
        >
          Ok
        </button>
      </Flex>
    </Flex>
  );
};

export default StatusViewMobile;
